import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
  HEADING_LEVEL,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import SvgIconLabel, {
  SVGICON_LABEL_POSITION,
  SVG_ICON_KIND,
  SVG_ICON_COLOR,
} from '@bit/gerenciatd.unifiedicons.svg-icon-label';
import Pill from '@bit/gerenciatd.unifiedcomponents.pill';
import {
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
  ICON_POSITION,
} from '@bit/gerenciatd.unifiedcomponents.button';
import { useProductModal } from '../../hooks/useProductModal';
import { actions as fusionActions } from '../../reducers/fusion';
import { iconsFeature } from '../../constants/iconsFeature';
import './CommerInfo.scss';

const CommerInfo = ({ feature, selectedProduct, taggingInfo }) => {
  const { changeSection } = useProductModal({ variant: null });
  const { products: recom } = useSelector((state) => state.fusion);
  const dispatch = useDispatch();

  const handleClickPill = (
    nameFeature,
    nombreParamCreatividad,
    valorParamCreatividad,
    tagAliasCreatividad
  ) => {
    const showSections = false;
    const showCta = false;
    const info = {
      group: recom.allProducts[Object.keys(recom.allProducts)[0]],
      selectedProduct,
      selected: 'FEATURE',
    };
    changeSection(info, nameFeature, showSections, showCta);
    dispatch(
      fusionActions.setCurrentCreativePill({
        nombreParamCreatividad,
        valorParamCreatividad,
        tagAliasCreatividad,
      })
    );
  };

  return (
    <div className="commer-info">
      <div className="commer-info__icon-wrapper">
        <SvgIconLabel
          sizeCircular={20}
          id={iconsFeature[feature.icon]}
          iconSize={32}
          labelSize={18}
          SvgIconLoader={SvgIconLoader}
          label={feature.title}
          labelColor={COLOR.BLACK}
          labelPosition={SVGICON_LABEL_POSITION.BOTTOM}
          kind={SVG_ICON_KIND.MEDIUM}
          iconColor={COLOR.WHITE}
          backgroundColor={SVG_ICON_COLOR.BLUE}
        />
      </div>
      <ul>
        {feature.info.map((eachInfo) => (
          <li className="commer-info__info-wrapper">
            <div className="commer-info__info-title">
              <TextInfo
                text={eachInfo.title}
                kind={KIND_TEXT.PARAGRAPH}
                align={ALIGN.CENTER}
                color={COLOR.GREY_5}
                size={SIZE.CAPTION3}
                fontType={FONT_TYPE.REGULAR}
              />
            </div>
            <ul className="commer-info__info-content">
              {eachInfo.claims.map((eachClaim) => (eachInfo.claimWithPills ? (
                <li className="commer-info__pill-wrapper">
                  <Pill
                    iconPosition={ICON_POSITION.LEFT}
                    color={eachClaim.data['color-pill-cms']}
                    label={eachClaim.data['tag-text']}
                    kind={KIND_TEXT.SPAN}
                    align={ALIGN.RIGHT}
                    taggingInfo={{
                      ...taggingInfo,
                      componentContent: eachClaim.data['tag-text'],
                    }}
                    size={{
                      w: BUTTON_WIDTH.LIQUID,
                      h: BUTTON_HEIGHT.SMALL,
                    }}
                    fontType={FONT_TYPE.REGULAR}
                    svgComponent={(
                      <SvgIconLoader
                        id={eachClaim.data['svg-id-cms']}
                        color={COLOR.BLUE}
                        kind={SVG_ICON_KIND.MEDIUM}
                        className="commer-info__pill-wrapper__icon"
                      />
)}
                    onClick={() => handleClickPill(
                      eachClaim.data['tag-text'],
                      eachClaim.data.nombreParametroCreatividad,
                      eachClaim.data.valorParametroCreatividad,
                      eachClaim.data.tag_alias_creatividad
                    )
                      }
                  />
                </li>
              ) : (
                <li className="commer-info__text-wrapper">
                  <TextInfo
                    text={eachClaim.body}
                    kind={KIND_TEXT.HEADING}
                    level={HEADING_LEVEL.H4}
                    align={ALIGN.LEFT}
                    color={COLOR.BLACK}
                    size={SIZE.CAPTION3}
                    fontType={FONT_TYPE.REGULAR}
                  />
                </li>
              )))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CommerInfo;
